import { useCurrentUser } from "../context/UserProvider";

const ALLOWED_ACTIONS = ["create", "read", "update", "delete"];

export const useAccessChecker = () => {
  const { currentUser } = useCurrentUser();

  const checkAccess = (section, action) => {
    // SuperAdmin always passes — mirrors the server-side bypass, so the
    // owner's sidebar/pages can never disappear because of a gap in the
    // stored permission matrix.
    if (currentUser?.role?.name === "SuperAdmin") {
      return true;
    }

    if (!currentUser?.role || !Array.isArray(currentUser.role.permissions)) {
      return false;
    }

    if (!section || !ALLOWED_ACTIONS.includes(action)) {
      return false;
    }

    const permission = currentUser.role.permissions.find(
      (item) => item?.section === section
    );

    return permission?.access?.[action] === true;
  };

  return { checkAccess };
};